import React, { Component } from "react"
export default class LoadingWithLabel extends Component {
  render() {
    return (
      <div className="load-9" style={this.props.style}>
        <h3
          style={{
            textAlign: "center",
            color: "white"
          }}
        >
          {this.props.label}
        </h3>
        <div className="spinner">
          <div className="bubble-1" />
          <div className="bubble-2" />
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/LoadingWithLabel.js